<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.4 16L11 12.4L14.6 16L16 14.6L12.4 11L16 7.4L14.6 6L11 9.6L7.4 6L6 7.4L9.6 11L6 14.6L7.4 16ZM11 21C9.61667 21 8.31667 20.7375 7.1 20.2125C5.88333 19.6875 4.825 18.975 3.925 18.075C3.025 17.175 2.3125 16.1167 1.7875 14.9C1.2625 13.6833 1 12.3833 1 11C1 9.61667 1.2625 8.31667 1.7875 7.1C2.3125 5.88333 3.025 4.825 3.925 3.925C4.825 3.025 5.88333 2.3125 7.1 1.7875C8.31667 1.2625 9.61667 1 11 1C12.3833 1 13.6833 1.2625 14.9 1.7875C16.1167 2.3125 17.175 3.025 18.075 3.925C18.975 4.825 19.6875 5.88333 20.2125 7.1C20.7375 8.31667 21 9.61667 21 11C21 12.3833 20.7375 13.6833 20.2125 14.9C19.6875 16.1167 18.975 17.175 18.075 18.075C17.175 18.975 16.1167 19.6875 14.9 20.2125C13.6833 20.7375 12.3833 21 11 21ZM11 19C13.2333 19 15.125 18.225 16.675 16.675C18.225 15.125 19 13.2333 19 11C19 8.76667 18.225 6.875 16.675 5.325C15.125 3.775 13.2333 3 11 3C8.76667 3 6.875 3.775 5.325 5.325C3.775 6.875 3 8.76667 3 11C3 13.2333 3.775 15.125 5.325 16.675C6.875 18.225 8.76667 19 11 19Z" fill="white"/>
    </svg>
</template>

<script>

export default {
  name: 'CancelIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
